<template>

	<transition-group name="bounce">
		<div v-show="Object.values(config.loaded).includes(false)" id="loading-screen" class="bg-primary" v-bind:key="0">
			<div class="center-me" style="width:170px;">
				<div class="brand">
				</div>

				<div class="mt-4 mb-3 text-center">
					Hang tight! Getting your...
				</div>

				<div class="d-flex align-items-baseline">
					<div class="rounded-circle circle-cropped avatar-sm text-white text-white mx-auto mb-1 text-center">
						<i class="fal fa-user-md fa-fw"></i>
					</div>
					<span class="flex-grow-1 ml-2 text-uppercase text-sm font-weight-bold text-white">Providers</span>
					<i :class="config.loaded.groups && config.loaded.physicians ? 'fal fa-check' : 'fad fa-circle-notch fa-spin'" />
				</div>
				<div class="d-flex align-items-baseline">
					<div class="rounded-circle circle-cropped avatar-sm text-white mx-auto mb-1 text-center">
						<i class="fal fa-fire-alt fa-fw"></i>
					</div>
					<span class="flex-grow-1 ml-2 text-uppercase text-sm font-weight-bold text-white">Activities</span>
					<i :class="config.loaded.routes && config.loaded.campaigns ? 'fal fa-check' : 'fad fa-circle-notch fa-spin'" />
				</div>
				<div class="d-flex align-items-baseline">
					<div class="rounded-circle circle-cropped avatar-sm text-white mx-auto mb-1 text-center">
						<i class="fal fa-users fa-fw"></i>
					</div>
					<span class="flex-grow-1 ml-2 text-uppercase text-sm font-weight-bold text-white">Accounts</span>
					<i :class="config.loaded.accounts ? 'fal fa-check' : 'fad fa-circle-notch fa-spin'" />
				</div>
				<div class="d-flex align-items-baseline">
					<div class="rounded-circle circle-cropped avatar-sm text-white mx-auto mb-1 text-center">
						<i class="fal fa-sliders-h fa-fw<"></i>
					</div>
					<span class="flex-grow-1 ml-2 text-uppercase text-sm font-weight-bold text-white">Settings</span>
					<i :class="config.loaded.options ? 'fal fa-check' : 'fad fa-circle-notch fa-spin'" />
				</div>
			</div>
		</div>

	    <div class="app" id="apptest" v-bind:key="1" :class="{'d-none' : Object.values(config.loaded).includes(false)}">	    	
			<header-layout></header-layout>
			<app-layout></app-layout>
			<footer-layout></footer-layout>
		</div>	
	</transition-group>
</template>



<script>
	import { mapState } from 'vuex';

	export default {
		computed: {
			...mapState(['config'])
		}
	}

</script>

<style>
.bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-in .5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}
	</style>